export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/38ca5171847470e09071b830d055b31c.png";